import { Box, ImageListItem, Paper, Theme } from "@mui/material";

import React, { useState } from "react";
import { Device } from "../../../../../../API";
import { S3ImageFullScreen } from "../../../../../../common/components/media/S3ImageFullScreen";
import { useS3ObjectLastModified } from "../../../../../../common/hooks/useS3ObjectLastModified";
import { useGetLocationsCached } from "../../../../../customer-settings/tabs/locations/hooks/useGetLocationsCached";
import DraggedModalBody from "../../../../../devices/device-details/components/model-settings/DraggedModalBody";
import LiveViewDialog from "../dialog/LiveViewDialog";
import DeviceImageListItemBarTitleContent from "./DeviceImageListItemBarTitleContent";
import DeviceLiveViewModalContent from "./DeviceLiveViewModalContent";
import { DEFAULT_MEDIA_ICON_STYLES } from "../../../../../../common/variables/common";

interface IDeviceImageListItemProps {
  device: Device;
}

const DeviceImageListItem = ({
  device,
}: IDeviceImageListItemProps): JSX.Element => {
  const { locations } = useGetLocationsCached("cache-only");

  const [openLiveViewDialog, setOpenLiveViewDialog] = useState(false);

  const handleLiveViewOnClickHandler = (): void => {
    setOpenLiveViewDialog(true);
  };

  const handleLiveViewOnCloseHandler = (): void => {
    setOpenLiveViewDialog(false);
  };

  const [open, setOpen] = useState(false);
  const { lastModified: imageDate } = useS3ObjectLastModified(
    device.deviceData.signedUrlRecentFrame
  );

  const deviceLocationId = device.locationId;

  const locationFromQuery = locations.find(l => l.id === deviceLocationId);

  const handleLiveViewOnClick = (): void => {
    setOpen(true);
  };

  const isOnline = device.healthData?.isOnline;

  return (
    <>
      <ImageListItem key={device.id} component="div">
        <Paper
          elevation={0}
          sx={{
            borderRadius: "12px",
            border: (theme: Theme): string =>
              `1px solid ${theme.palette.divider}`,
            width: "100%",
            height: "100%",
            padding: "0.5em",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "220px",
              borderRadius: "8px",
              border: (theme): string =>
                `1px solid ${theme.palette.otherOutlineBorder.main}`,
            }}
          >
            <S3ImageFullScreen
              sx={{
                ...DEFAULT_MEDIA_ICON_STYLES,
                width: "100%",
                borderRadius: "8px",
                height: "220px",
                objectFit: "fill",
              }}
              mediaStatusSx={{
                width: "100%",
                borderRadius: "8px",
                height: "220px",
                objectFit: "fill",
              }}
              deviceStatus={true}
              variant="image"
              s3Key={device.deviceData.signedUrlRecentFrame ?? ""}
              onClickVideoIcon={handleLiveViewOnClick}
            />
          </Box>

          {open && (
            <LiveViewDialog
              setOpen={setOpen}
              deviceId={device.id}
              deviceName={device.name}
              locationName={locationFromQuery?.name ?? "-"}
              nodeId={device.nodeId}
              hasPanTilt={device.deviceData.hasPanTilt}
              hasZoom={device.deviceData.hasZoom}
              deviceData={device.deviceData}
              currentPosition={device.currentPosition}
              currentDevice={device.id}
            />
          )}

          <DeviceImageListItemBarTitleContent
            deviceId={device.id}
            deviceName={device.name}
            locationName={locationFromQuery?.name ?? "-"}
            imageDate={imageDate}
            nodeId={device.nodeId}
            isOnline={isOnline}
            hasPanTilt={device.deviceData.hasPanTilt}
            onLiveViewClick={handleLiveViewOnClickHandler}
            recentFrame={device.deviceData.recentFrame || ""}
          />
        </Paper>
      </ImageListItem>

      <DraggedModalBody
        title="Live view"
        open={openLiveViewDialog}
        persistId="live-view"
        width={"90vw"}
        height={"85vh"}
        onClose={handleLiveViewOnCloseHandler}
      >
        <DeviceLiveViewModalContent
          device={device}
          locationName={locationFromQuery?.name ?? "-"}
        />
      </DraggedModalBody>
    </>
  );
};

export default React.memo(DeviceImageListItem);
